import { observer } from 'mobx-react-lite'
import { type BookkeepingCycleDetailsDialogViewModel } from './BookkeepingCycleDetailsDialogViewModel'
import { BookkeepingCycleDetailsDialog } from '@/features/jobs/details/components/BookkeepingCycleDetailsDialog'

export interface BookkeepingCycleDetailsDialogContainerProps {
  vm: BookkeepingCycleDetailsDialogViewModel
}

export const BookkeepingCycleDetailsDialogContainer = observer(
  function BookkeepingCycleDetailsDialogContainer({
    vm,
  }: BookkeepingCycleDetailsDialogContainerProps) {
    return (
      <BookkeepingCycleDetailsDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        cycleNumber={vm.cycle.number}
        statusName={vm.statusName}
        startedAt={vm.cycle.startedAt}
        correctedAt={vm.cycle.correction?.correctedAt}
        completedAt={vm.completedAt}
        isCompleted={vm.isCompleted}
        completedWorkItems={vm.completedWorkItemsInCycle}
      />
    )
  },
)
